import "./css/vue-context.css";
const VueContext = require("./js/vue-context.js");

// export const ContextMenu = {
// 	install(vue:any, options:any){
// 		vue.component("vue-context", VueContext.default);
// 	}
// };

export const ContextMenu = VueContext.default;